import { render, staticRenderFns } from "./CourierDetail.vue?vue&type=template&id=6336bb9e&"
import script from "./CourierDetail.vue?vue&type=script&lang=js&"
export * from "./CourierDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports